// extracted by mini-css-extract-plugin
export var disabled = "_18-a";
export var hierarchyLinkGray = "_18-4";
export var hierarchyLinkUnderline = "_18-3";
export var hierarchyPrimary = "_18-0";
export var hierarchySecondary = "_18-1";
export var hierarchyTertiary = "_18-2";
export var pressed = "_18-6";
export var themeAction = "_18-5";
export var themeDestructive = "_18-8";
export var themeNormal = "_18-7";
export var themeSuccess = "_18-9";